var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainCenter',[_c('Article',{attrs:{"article":{ type: 12 }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }